import axios from "axios";
import jwt_decode from "jwt-decode";
import { logOut } from "../../common/utils";
import { Toast } from "bootstrap";
import { toast } from "react-toastify";
import TicketsService from "../tickets/ticketsService";

export default class LoginService{



   
   login(utente, password, cf, deviceUUID,  onSuccess, onError, onOTP, onPasswordExpired){
        sessionStorage.clear();
      let host = process.env.REACT_APP_API_URL;
      const headers = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin' : '*',
      'Access-Control-Allow-Headers' : 'Origin, X-Requested-With, Content-Type, Accept',
      'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
   };

   

  //  console.log("Login request" , {utente, password, codicefiscale: cf, url :`${host}/public/auth/login`});
   axios.post(host+"/public/auth/login",
                                 {
                                    utente:utente, 
                                    password:password, 
                                    codiceFiscale:cf,
                                    idDevice: `${utente}-${deviceUUID}`
                                },
                                {
                                    headers: headers
                                }
  )
          .then(
            function(result){
              let ticketService = new TicketsService();
         var decoded = jwt_decode(result.data.token);
         ticketService.retriveTicketToken(
          result.data.token,
          ()=>{
            return;
          },
          ()=>{
            toast.error("Impossibile collegarsi al servizio segnalazioni.");
          }
         )

        //  localStorage.setItem("token_exp", decoded.exp);
         if(decoded.RUOLO === 0 || decoded.RUOLO ==="0"){
          onError(decoded.RUOLO)
         }else{
            var result = "{\"username\":\""+utente+"\",\"token\":\""+result.data.token+"\"}";
            sessionStorage.setItem('user', result);
            onSuccess(result);
        }
       }
        , function(error){
    console.error(" Login error", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      headers: error.response?.headers,
    });
          if(error.response?.status === 428){
            onOTP();
          }else if (error.response?.status === 401 && error.response?.data?.token ) {
              console.warn("Password scaduta, richiedi il cambio password.");
              onPasswordExpired(error.response?.data?.token);

    } 
      else{
              console.error("Errore durante il login: ", error);
              onError(error);
          }
        
   }
  );
//   setTimeout(() => {
//   const fakeError = {
//     response: {
//       status: 428,
//     }
//   };

//   console.log("Simulazione errore OTP:", fakeError);

//   if (fakeError.response?.status === 428) {
//     onOTP(); // forza apertura della modale OTP
//   } else {
//     onError(fakeError);
//   }
// }, 1000);

} 


otpCheck (utente, password,cf, idDevice,  otp, onSuccess, onError){
  let host = process.env.REACT_APP_API_URL;
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Headers' : 'Origin, X-Requested-With, Content-Type, Accept',
    'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
  };
  axios
    .post(
      host + "/public/auth/login" ,
      {
        utente: utente,
        password: password,
        codiceFiscale: cf,
        idDevice: `${utente}-${idDevice}`,
        otp: otp,
      },
      { headers}
    )
    .then(
      function (result) {
        const decoded = jwt_decode(result.data.token);
        const user = {
          username: utente,
          token: result.data.token,
          cf: decoded.CFA,
        };
        let ticketService = new TicketsService();
        sessionStorage.setItem("user" , JSON.stringify(user));
         ticketService.retriveTicketToken(result.data.token,
          ()=>{
            return;
          },
          ()=>{
            toast.error("Impossibile collegarsi al servizio segnalazioni.");
          }
         )
        onSuccess(user);
      },
      function(error) {
        console.error("Errore OTP:" , error);
        onError(error);
      }
    )
}

changePassword( oldPassword, newPassword, onSuccess, onError, tk=null,fc=null,) {
  let host = process.env.REACT_APP_API_URL;
  const headers = {
    Authorization: "Bearer " + (tk ?tk : JSON.parse(sessionStorage.getItem("user")).token),
                CF: fc ?fc : jwt_decode(JSON.parse(sessionStorage.getItem("user")).token).CFA,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
                "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  };

  axios
    .post(`${host}/api/v1/user/changePassword`, {
    
      oldPassword,
      newPassword,
      
    }, { headers })
    .then(
       function (result) {
                if(result.status === 200) {
                    onSuccess(result.data);
                } else if(result.status === 401){
                    onError();
                    //logOut();
                } else {
                    onError();
                }
            },
      function (error)  {
        
        onError(error);
      }
    );
}

retriveTicketToken (tk,onSuccess,onError){
  let host = process.env.REACT_APP_API_URL;
  try{
  const headers = {
    Authorization: "Bearer " + tk,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
                "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  };
  axios
    .post(host + "/api/v1/manage/tickets/public/auth/login",null,headers).then(
      (result)=>{
        sessionStorage.setItem("ticket_user",JSON.stringify(result.data));
        onSuccess();
      },
      (error)=>{
        onError();
      }
    )
  }catch(e){
    console.log("Errore nel retriveTicketToken: ", e);
  }
}

getImpostazioni(onSuccess){
   let host = process.env.REACT_APP_API_URL;
   var objUser = JSON.parse(sessionStorage.getItem("user"));
   var decoded = jwt_decode(objUser.token);
   const configHeaders = {
     headers: {
       Authorization: "Bearer " + objUser.token,
       CF: decoded.CFA,
       "Content-Type": "application/json",
       "Access-Control-Allow-Origin": "*",
       "Access-Control-Allow-Headers":
         "Origin, X-Requested-With, Content-Type, Accept",
       "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
     },
   };
   axios
     .get(host + "/api/v1/impostazioni/findAll", configHeaders)
     .then(
       function (result) {
        if(result.status === 401){
          logOut();
        }
         result.data.map((val) => {
          
            //  if(val.key === "help_desk"){
            //    sessionStorage.removeItem("key-Segnalazioni");
            //    sessionStorage.setItem('key-Segnalazioni', JSON.stringify(val));
            // }
            sessionStorage.removeItem(val.key);
            sessionStorage.setItem("Imp_" +val.key, JSON.stringify(val.value));
            return <></>
         })
        //  console.log(result.data);
         onSuccess(result.data);
       },
       function (error) {
        if(error.response.status === 401){
          logOut();
        }
        //  console.log(
        //    "errore " + error
        //  );
         onSuccess([]);
       }
     );
}


}